const transitionProperties = {
  control: '150ms ease-out',
};

export const transitions = {
  control: `
    background ${transitionProperties.control},
    box-shadow ${transitionProperties.control},
    color ${transitionProperties.control},
    fill ${transitionProperties.control},
    opacity ${transitionProperties.control},
    outline ${transitionProperties.control},
    stroke ${transitionProperties.control},
    transform ${transitionProperties.control}
  `,
};
